import { createContext } from 'react';

import type {
  InspiredPaymentPortalAPIAccessibleAccountsAccessibleAccountDto as AccessibleAccount,
  InspiredPaymentPortalAPISettingsFilterSettings,
  InspiredLibrariesApiExceptionHandlingErrorResponse
} from 'shared/models/payments';
import { ErrorType } from 'shared/utils/axiosInstance';
import { noop } from 'shared/helpers/noop';

interface AccessibleAccountsContextType {
  currentAccount: AccessibleAccount | null;
  setCurrentAccount: (account: AccessibleAccount | null) => void;
  shouldShowAccountSwitcher: boolean;
  availableAccounts: AccessibleAccount[];
  isCurrentAccountObserver: boolean;
  filters: InspiredPaymentPortalAPISettingsFilterSettings;
  hasFilters: boolean;
  paymentRoutesDisabled: boolean;
  defaultAcademicYear: string;
  isLoading: boolean;
  error: ErrorType<InspiredLibrariesApiExceptionHandlingErrorResponse> | null;
}

export default createContext<AccessibleAccountsContextType>({
  currentAccount: null,
  setCurrentAccount: noop,
  shouldShowAccountSwitcher: false,
  availableAccounts: [],
  isCurrentAccountObserver: false,
  filters: { academicYears: [], invoiceStatuses: [], paymentStatuses: [] },
  hasFilters: false,
  paymentRoutesDisabled: false,
  defaultAcademicYear: '',
  isLoading: false,
  error: null
});
